module.exports = __webpack_public_path__ + "static/img/comfirBtnGaen.c7b68d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/comfirBtnGaen.png
// module id = SA7T
// module chunks = 1